import React from "react";
import { Link } from "react-router-dom";
import Button from "material-ui/Button";
import Typography from "material-ui/Typography";
import Icon from "material-ui/Icon";
import { withStyles } from "material-ui/styles";
import styles from "./styles";

const BackCheck = ({ toCheck, title, classes }) => {
  return (
    <div className={classes.root}>
      <Typography>
        <Button className={classes.backCheck} onClick={toCheck}>
          <Typography className={classes.backCheckText}>{title}</Typography>
          {/* {title} */}
        </Button>
      </Typography>

      <Typography>
        <Icon>chevron_right</Icon>
      </Typography>
    </div>
  );
};

export default withStyles(styles)(BackCheck);
